import React from 'react'
import { InfoBox } from '@mobi/component-library/Feedback/InfoBox'
import { useAppSelector } from '@mobi/betslip/Store/hooks'
import { selectApiErrorMessage } from '@mobi/betslip/Store/Workflow/selectors'

export const ApiErrorMessage: React.FC = () => {
  const apiErrorMessage = useAppSelector(selectApiErrorMessage)

  if (!apiErrorMessage) return null

  return (
    <InfoBox size='md' color='red'>
      <span>Error</span>
      <div>{apiErrorMessage}</div>
    </InfoBox>
  )
}
